import React, {
  useRef,
  useState,
  useEffect
} from 'react';
import { useSnackbar } from 'notistack';
import { useHistory } from 'react-router';

import {
  useDispatch,
  useSelector
} from 'react-redux';
import {
  IconButton, 
  Menu,
  MenuItem,
  SvgIcon,
  Tooltip,
  makeStyles
} from '@material-ui/core';
import {
  User as UserIcon
} from 'react-feather';
import { getNotifications } from 'src/actions/notificationsActions';
import { logout } from 'src/actions/accountActions';

const useStyles = makeStyles((theme) => ({
  popover: {
    width: 320
  },
  icon: {
    backgroundColor: '#5850ec',
    color: '#ffffff'
  }
}));

function Notifications() {
  const classes = useStyles();
  const history = useHistory();
  const ref = useRef(null);
  const dispatch = useDispatch();
  const [isOpen, setOpen] = useState(false);
  
  const account = useSelector(state => state.account);
  const { enqueueSnackbar } = useSnackbar();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    try {
      handleClose();
      await dispatch(logout());

      history.push('/');
    } catch (error) {
      enqueueSnackbar('Unable to logout', {
        variant: 'error'
      });
    }
  };
  
  
  const handleTrocarSenha = async () => {
    try {    
      history.push('/app/cadastros/trocarsenha');
    } catch (error) {
      enqueueSnackbar('Unable to logout', {
        variant: 'error'
      });
    }
  };
  

  useEffect(() => {
    dispatch(getNotifications());
  }, [dispatch]);

  return (
    <>
      <Tooltip title="Notificações">
        <IconButton
          ref={ref}
          onClick={handleOpen}
        >
         <SvgIcon fontSize="medium">
              <UserIcon />
         </SvgIcon>
        </IconButton>
      </Tooltip>
      <Menu
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        keepMounted
        PaperProps={{ className: classes.popover }}
        getContentAnchorEl={null}
        anchorEl={ref.current}
        open={isOpen}
      >
        <MenuItem onClick={handleTrocarSenha}>Alterar Senha</MenuItem>
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </>
  );
}

export default Notifications;
